import { render, staticRenderFns } from "./NationalPatentList.vue?vue&type=template&id=3c19f2ca&"
import script from "./NationalPatentList.vue?vue&type=script&lang=js&"
export * from "./NationalPatentList.vue?vue&type=script&lang=js&"
import style0 from "./NationalPatentList.vue?vue&type=style&index=0&id=3c19f2ca&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports